"use client";

import { useQueryClient } from "@tanstack/react-query";

import { useMarkAllRead as useMarkAllReadMutation } from "@/lib/api/generated";

import { NOTIFICATIONS_KEY } from "./use-notifications";
import { UNREAD_COUNT_KEY } from "./use-unread-count";

export function useMarkAllRead() {
  const queryClient = useQueryClient();
  return useMarkAllReadMutation({
    mutation: {
      onMutate: async () => {
        await queryClient.cancelQueries({ queryKey: UNREAD_COUNT_KEY });
        const prev = queryClient.getQueryData(UNREAD_COUNT_KEY);
        queryClient.setQueryData(UNREAD_COUNT_KEY, { count: 0 });
        return { prev };
      },
      onError: (_err, _vars, context) => {
        if (context?.prev) {
          queryClient.setQueryData(UNREAD_COUNT_KEY, context.prev);
        }
      },
      onSettled: () => {
        queryClient.invalidateQueries({ queryKey: NOTIFICATIONS_KEY });
        queryClient.invalidateQueries({ queryKey: UNREAD_COUNT_KEY });
      },
    },
  });
}
